"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const criteria_builder_1 = require("../../#lib/building/criteria-builder");
const lexer_1 = require("./lexical-analysis/lexer");
const map_ast_to_expression_tree_1 = require("./syntax/map-ast-to-expression-tree");
const recursive_descent_parser_1 = require("./syntax/recursive-descent-parser");
function parse(expression) {
    const lexer = new lexer_1.Lexer();
    const parser = new recursive_descent_parser_1.RecursiveDescentParser();
    const ast = parser.parse(lexer.tokenize(expression));
    const expressionTree = map_ast_to_expression_tree_1.mapAstToExpressionTree(ast);
    return new criteria_builder_1.CriteriaBuilder(expressionTree);
}
exports.parse = parse;
//# sourceMappingURL=parse.js.map